<template>
  <div class="profile">
    <profile-header>
      <div class="other_profile_avatar">
        <div class="avatar_status"> <img :src="getSelectedUser.avatar" alt="">
          <div :class="[ isOnline() ? 'bubble_online' : 'bubble_ofline', 'large' ]">
            <span class="bubble-outer-dot">
              <span class="bubble-inner-dot"></span>
            </span>
          </div>
        </div>
      </div>
      <div class="other_user_info">
        <span class="name">{{ getSelectedUser.username }}</span>
        <span class="name level" v-if="!getSelectedUser.hasPrivateProfile">
          {{ getTranslations.home_profile_profile_level }}: {{ getSelectedUser.level }}
        </span>
        <span class="name achiev"></span>
        <div class="action_container">
          <chat-bubble v-if="getMessagingConfig.messagingEnabled"
                       :class="[{ deactivated: getSelectedUser.bot || getSelectedUser.hasBlockedYou }]"
                       :username="getSelectedUser.username"/>
          <star :action-on-click="markFavorite" :is-checked="getSelectedUser.isFavorite" :key-id="_uid"/>
          <block :action-on-click="blockUser" :is-checked="getSelectedUser.blocked" :key-id="_uid"/>
        </div>
      </div>
      <div class="challenge_btn">
        <a style="cursor:pointer" :class="['btn2 btn--v2 btn2--medium btn2--green', { deactivated: !isOnline() }]" @click.prevent="openModalConfirmChallenge()">
          {{ getTranslations.home_other_users_profile_challenge }}
        </a>
      </div>
    </profile-header>
    <performance v-if="!getSelectedUser.hasPrivateProfile"
                 :title="getTranslations.home_profile_default_content_your_performance"
                 :sub-title="getTranslations.home_profile_default_content_theme_performance"
                 :fit="true"
                 :user-info="getSelectedUser.userInfo || {}"
                 :themes="getSelectedUser.themes || []"/>
    <fade-transition>
      <block-user v-if="showBlockModal" @close="toggleBlockModal"/>
    </fade-transition>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import ProfileHeader from '@/components/home/profile/ProfileHeader';
import Performance from '@/components/home/profile/Performance';
import Star from '@/components/home/shared/Star';
import Block from '@/components/home/shared/Block';
import ChatBubble from '@/components/home/shared/ChatBubble';
import BlockUser from '@/components/home/modals/users/BlockUser';
import RequestForRematch from '@/common/mixins/extraRematchInfo';
import FadeTransition from '@/components/home/modals/shared/FadeTransition';
import ConfirmChallengeRequest from '../game/challenge/ConfirmChallengeRequest';

export default {
  name: 'other_user_profile',
  mixins: [RequestForRematch],
  components: {
    ChatBubble,
    ProfileHeader,
    Performance,
    Star,
    Block,
    BlockUser,
    FadeTransition,
  },
  created() {
    if (!Object.keys(this.getSelectedUser).length) this.$router.push({ name: 'home' });
    if (!this.getSelectedUser.bot) this.fetchUserStats(this.getSelectedUser.username);
  },
  data() {
    return {
      showBlockModal: false,
    };
  },
  methods: {
    ...mapMutations('users', [
      'refreshSelectedUser',
    ]),
    ...mapActions('users', [
      'markFavoriteUser',
      'markBlockedUser',
      'fetchUserStats',
    ]),
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    markFavorite() {
      this.markFavoriteUser(this.getSelectedUser.username);
      this.refreshSelectedUser();
    },
    toggleBlockModal() {
      this.showBlockModal = !this.showBlockModal;
    },
    blockUser() {
      if (!this.getSelectedUser.blocked) this.toggleBlockModal();
      else {
        this.markBlockedUser(this.getSelectedUser.username);
        this.refreshSelectedUser();
      }
    },
    openModalConfirmChallenge() {
      this.storeModalForHomePage(ConfirmChallengeRequest);
    },
    isOnline() {
      return this.getSelectedUser.bot ||
        (this.getOnlineUsers.filter(user => user && user.username === this.getSelectedUser.username).length && !this.getSelectedUser.hasBlockedYou);
    },
  },
  computed: {
    ...mapGetters('users', [
      'getSelectedUser',
    ]),
    ...mapGetters('users', [
      'getOnlineUsers',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('common', [
      'getMessagingConfig',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/users/OtherUserProfile.vue